import React, { useState, useEffect, useRef, useContext } from "react";
import "./dashboard.css";
import axios from "axios"; // NEW
import { toast } from "react-toastify"; // NEW
import Sidebar from "./sidebar/sidebar.js";
import { PopupContext } from "../PopupContext.js";
import PopupUnlimitedBonus from "../unlimited_Bonus/unlimited_Bonus.js";
import PopupWallets from "../Wallets/wallets.js";
import ClientInvoices from "../invoices/ClientInvoices.js";
import PackLogos from "../sousPacks/packnvpu/PackLogos.js";
import ClientInvoicesPayed from "../invoices/ClientInvoicesPayed.js";
import { ArrowLeft, Lock } from "lucide-react"; // CHANGED : + Lock
import PopupTasks from "../tasks/tasks.js";
import { Link } from "react-router-dom";
import FacilityVip from "../FacilityVip/facilityVip.js";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";
const VIP_LOCKED_MESSAGE =
  "Unlimited Bonus VIP is not available because you bought a normal pack.";
const NORMAL_LOCKED_MESSAGE =
  "Unlimited Bonus is not available because you bought a VIP pack.";

// Blocs "normaux" verrouillés quand le client a acheté un pack VIP.
// (retire "UnlimitedBonusInternational" de la liste si seul le Local doit être bloqué)
const NORMAL_BLOCKS = ["UnlimitedBonusLocal", "UnlimitedBonusInternational"];

function Dashboard({ userId }) {
  const { openParentPack, openPackParent, popupRef, closeAllPopups } =
    useContext(PopupContext);
  const logosContainerRef = useRef(null);

  // NEW : VIP bloqué si le client a acheté un pack normal ;
  // blocs normaux (Local / International) bloqués s'il a acheté un pack VIP
  const currentUserId = userId || localStorage.getItem("userId");
  const [vipLocked, setVipLocked] = useState(false); // a acheté un pack normal
  const [normalLocked, setNormalLocked] = useState(false); // a acheté un pack VIP

  // Handle logo clicks to open the appropriate popup
  const handleLogoClick = (packName) => {
    // NEW : garde — impossible d'ouvrir le bloc VIP s'il est verrouillé
    if (packName === "UnlimitedBonusVip" && vipLocked) {
      toast.info(VIP_LOCKED_MESSAGE);
      return;
    }
    if (NORMAL_BLOCKS.includes(packName) && normalLocked) {
      toast.info(NORMAL_LOCKED_MESSAGE);
      return;
    }
    console.log(`Clicked on ${packName}`);
    closeAllPopups(); // Ferme tous les autres popups avant d'ouvrir un nouveau
    openPackParent(packName); // Met à jour openParentPack via le contexte
  };

  // NEW : vérifie l'accès aux blocs au chargement, puis à chaque fermeture d'un popup
  // (par exemple juste après l'achat d'un pack normal)
  useEffect(() => {
    if (openParentPack || !currentUserId) return undefined;

    let cancelled = false;

    axios
      .get(`${API_URL}/pack-access/${currentUserId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        if (cancelled || !res.data) return;
        setVipLocked(Boolean(res.data.vipLocked));
        setNormalLocked(Boolean(res.data.normalLocked));
      })
      .catch((err) => console.error("Pack access check failed:", err.message));

    return () => {
      cancelled = true;
    };
  }, [openParentPack, currentUserId]);

  // Handle scroll behavior for logos container
  useEffect(() => {
    const checkScroll = () => {
      const container = logosContainerRef.current;
      if (!container) return;

      const containerHeight = container.scrollHeight;
      const viewportHeight = window.innerHeight - 100; // Adjusted for margins and padding

      if (containerHeight > viewportHeight) {
        container.classList.add("scroll-enabled");
      } else {
        container.classList.remove("scroll-enabled");
      }
    };

    checkScroll();
    window.addEventListener("resize", checkScroll);

    return () => window.removeEventListener("resize", checkScroll);
  }, []);
  // Liste des types de packs qui utilisent PackLogos
  const packLogosTypes = [
    "PackUltraOne",
    "PackNVPU",
    "PackSXMG",
    "PackSXMGsp",
    "PackRRRR",
    "PackRS",
    "PackTD",
    "PackABIR",
  ];
  return (
    <div className="dashboardClient">
      <Sidebar />
      <div className="dashboard-backgroundClient">
        <div className="overlayClient">
          <div className="logos-containerClient" ref={logosContainerRef}>
            <div
              className={`logo-item-dashboardClient ${
                normalLocked ? "is-locked" : ""
              }`}
              aria-disabled={normalLocked}
              title={
                vipLocked
                  ? "Not available: you bought a normal pack"
                  : undefined
              }
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("UnlimitedBonusLocal");
              }}
            >
              <img
                src="/images/services/1.png"
                alt=">Unlimited Bonus Local"
                className="logo-dashboardClient"
              />
              {normalLocked && (
                <span className="vip-lock-badge" aria-hidden="true">
                  <Lock size={14} />
                </span>
              )}
              <span className="logo-name-dashboardClient">
                Unlimited Bonus Local
              </span>
            </div>

            {/* CHANGED : bloc VIP verrouillé si un pack normal a été acheté */}
            <div
              className={`logo-item-dashboardClient ${
                vipLocked ? "is-locked" : ""
              }`}
              aria-disabled={vipLocked}
              title={
                vipLocked
                  ? "Not available: you bought a normal pack"
                  : undefined
              }
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("UnlimitedBonusVip");
              }}
            >
              <img
                src="/images/services/unlimited_BonusVIP.png"
                alt="Unlimited Bonus VIP"
                className="logo-dashboardClient"
              />
              {vipLocked && (
                <span className="vip-lock-badge" aria-hidden="true">
                  <Lock size={14} />
                </span>
              )}
              <span className="logo-name-dashboardClient">
                Unlimited Bonus VIP
              </span>
            </div>

            {/* CHANGED : verrouillé si un pack VIP a été acheté */}
            <div
              className={`logo-item-dashboardClient ${
                normalLocked ? "is-locked" : ""
              }`}
              aria-disabled={normalLocked}
              title={
                normalLocked
                  ? "Not available: you bought a VIP pack"
                  : undefined
              }
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("UnlimitedBonusInternational");
              }}
            >
              <img
                src="/images/services/ulimitedBonusInterna.png"
                alt="UnlimitedBonusInternational"
                className="logo-dashboardClient"
              />
              {/* {normalLocked && (
                <span className="vip-lock-badge" aria-hidden="true">
                  <Lock size={14} />
                </span>
              )} */}
              <span className="logo-name-dashboardClient">
                {" "}
                Unlimited Bonus International{" "}
              </span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/2.png"
                alt="apple for you"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient"> Appel For You </span>
            </div>
            <div
              className="logo-item-dashboardClient"
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("PopupFacilityVip");
              }}
            >
              <img
                src="/images/services/3.jpg"
                alt=" Facility VIP"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient"> Facility VIP </span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/4.png"
                alt="Cash Back"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient"> Cash Back </span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/5.png"
                alt="By Win"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient"> Buy Win </span>
            </div>
            <div
              className="logo-item-dashboardClient"
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("RepairService");
              }}
            >
              <img
                src="/images/services/6.png"
                alt="Repair Service"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Repair Service</span>
            </div>

            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/7.png"
                alt=" the joker challenge"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">
                The Joker Challenge
              </span>
            </div>

            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/8.png"
                alt="gaming "
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Gaming</span>
            </div>
            <Link
              to="/Ludo-Champions-League"
              className="logo-item-dashboardClient"
            >
              <div className="logo-item-dashboardClient">
                <img
                  src="/images/services/9.png"
                  alt="Ludo  Champions"
                  className="logo-dashboardClient"
                />

                <span className="logo-name-dashboardClient">
                  Ludo Champions League
                </span>
              </div>
            </Link>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/10.png"
                alt="Champions League MWG Football"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">
                Champions League MWG Football
              </span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/11.png"
                alt="Wiwi Technology"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Wiwi Technology</span>
            </div>

            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/34.png"
                alt="Logo 34"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">IA</span>
            </div>

            <div
              className="logo-item-dashboardClient"
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("PopupWallets");
              }}
            >
              <img
                src="/images/services/12.png"
                alt="Logo 12"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Wallets</span>
            </div>
            <Link to="/category" className="logo-item-dashboardClient">
              <div className="logo-item-dashboardClient">
                <img
                  src="/images/services/13.png"
                  alt="Marketplace"
                  className="logo-dashboardClient"
                />

                <span className="logo-name-dashboardClient">Marketplace</span>
              </div>
            </Link>
            <div
              className="logo-item-dashboardClient"
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("Popuptasks");
              }}
            >
              <img
                src="/images/services/14.png"
                alt="tasks"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Tasks</span>
            </div>
            <div
              className="logo-item-dashboardClient"
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("PopupInvoices");
              }}
            >
              <img
                src="/images/services/15.png"
                alt="Invocies"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Invocies</span>
            </div>

            <div
              className="logo-item-dashboardClient"
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("PopupInvoicesPayed");
              }}
            >
              <img
                src="/images/services/16.png"
                alt="Invocies Paid "
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Invocies Paid</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/17.png"
                alt="News"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">News</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/18.png"
                alt="Event"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Event</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/19.png"
                alt="Protection"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Protection</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/20.png"
                alt="Gift"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Gift</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/21.png"
                alt="Gift Ultra"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Gift Ultra</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/painting.png"
                alt="painting "
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">painting</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/23.png"
                alt="Music"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Music</span>
            </div>

            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/25.png"
                alt="podcast"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Podcast</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/24.png"
                onClick={() => window.open("https://www.youtube.com/@MWGTD")}
                alt="Youtube"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Youtube</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/26.png"
                onClick={() =>
                  window.open(
                    "https://www.tiktok.com/@mwg.td?_t=ZM-8xML8yN4vBe&_r=1",
                  )
                }
                alt="Tiktok"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Tiktok</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/27.png"
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/mwg__2018?igsh=MXN5aWxyN3dweXpneg%3D%3D&utm_source=qr",
                    "_blank",
                  )
                }
                alt="Instagram"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Instagram</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/28.png"
                onClick={() =>
                  window.open(
                    "https://www.threads.com/@mwg__2018?igshid=NTc4MTIwNjQ2YQ== ",
                  )
                }
                alt="Threads"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Threads</span>
            </div>
            <div
              className="logo-item-dashboardClient"
              onClick={() =>
                window.open("https://www.facebook.com/MWGTD", "_blank")
              }
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                src="/images/services/29.png"
                alt="Facebook"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Facebook</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/30.png"
                alt="Linkedin"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Linkedin</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/31.png"
                onClick={() => window.open("https://x.com/mwgtd201822?s=21")}
                alt="X"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">X</span>
            </div>
            <div className="logo-item-dashboardClient">
              <a
                href="https://t.me/Smwgtd"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/images/services/32.png"
                  alt="Telegram"
                  className="logo-dashboardClient"
                />
              </a>
              <span className="logo-name-dashboardClient">Telegram</span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/33.png"
                alt="WhatsApp"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">WhatsApp</span>
            </div>

            <div
              className="logo-item-dashboardClient"
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("PackUltraOne");
              }}
            >
              <img
                src="/images/services/ultra-one.jpg"
                alt="ultraOne"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Pack ULTRA </span>
            </div>

            <div
              className="logo-item-dashboardClient"
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("PackNVPU");
              }}
            >
              <img
                src="/images/services/35.png"
                alt="Logo 35"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Pack NVPU </span>
            </div>
            <div
              className="logo-item-dashboardClient"
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("PackABIR");
              }}
            >
              <img
                src="/images/services/packABIR.png"
                alt="packABir"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Pack ABIR </span>
            </div>

            <div
              className="logo-item-dashboardClient"
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("PackSXMG");
              }}
            >
              <img
                src="/images/services/36.png"
                alt="Logo 37"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Pack SXMG </span>
            </div>
            <div
              className="logo-item-dashboardClient"
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("PackSXMGsp");
              }}
            >
              <img
                src="/images/services/37.png"
                alt="Logo 38"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Pack SXMGsp </span>
            </div>
            <div
              className="logo-item-dashboardClient"
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("PackRRRR");
              }}
            >
              <img
                src="/images/services/packRRRR.jpeg"
                alt="Logo 39"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Pack RRRR </span>
            </div>
            <div
              className="logo-item-dashboardClient"
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("PackRS");
              }}
            >
              <img
                src="/images/services/packRS.jpeg"
                alt="Logo 40"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Pack RS </span>
            </div>
            <div
              className="logo-item-dashboardClient"
              onClick={(event) => {
                event.stopPropagation();
                handleLogoClick("PackTD");
              }}
            >
              <img
                src="/images/services/packTD.jpeg"
                alt="Logo 41"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Pack TD </span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/39.png"
                alt="Logo 42"
                className="logo-dashboardClient"
              />
              <span className="logo-name-dashboardClient">Pack KING </span>
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/40.png"
                alt="Logo 43"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/facilityVIP.png"
                alt="Logo 44"
                className="logo-dashboardClient"
              />
            </div>
            <div className="logo-item-dashboardClient">
              <img
                src="/images/services/cach_back.png"
                alt="Logo 45"
                className="logo-dashboardClient"
              />
            </div>

            {/* Unified popup rendering based on openParentPack */}
            {openParentPack && (
              <div className="overlayUB" onClick={() => openPackParent(null)}>
                <div
                  ref={popupRef}
                  className="PopupUnlimitedBonus-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* {openParentPack === "UnlimitedBonus" && (
                    <PopupUnlimitedBonus onClose={() => openPackParent(null)} />
                  )} */}
                  {openParentPack === "UnlimitedBonusLocal" &&
                    !normalLocked && (
                      <PopupUnlimitedBonus
                        packType="local"
                        onClose={() => openPackParent(null)}
                      /> // Passe 'local' pour filtrer
                    )}
                  {/* CHANGED : jamais affiché si le VIP est verrouillé */}
                  {openParentPack === "UnlimitedBonusVip" && !vipLocked && (
                    <PopupUnlimitedBonus
                      variant="vip"
                      onClose={() => openPackParent(null)}
                    />
                  )}
                  {/* {openParentPack === "UnlimitedBonusInternational" && !normalLocked && (
                    <PopupUnlimitedBonus
                      packType="international"
                      onClose={() => openPackParent(null)}
                    /> 
                  )} */}
                  {openParentPack === "PopupWallets" && (
                    <PopupWallets onClose={() => openPackParent(null)} />
                  )}
                  {openParentPack === "Popuptasks" && (
                    <PopupTasks onClose={() => openPackParent(null)} />
                  )}
                  {openParentPack === "PopupFacilityVip" && (
                    <FacilityVip onClose={() => openPackParent(null)} />
                  )}
                  {openParentPack === "PopupInvoices" && (
                    <ClientInvoices onClose={() => openPackParent(null)} />
                  )}
                  {openParentPack === "PopupInvoicesPayed" && (
                    <ClientInvoicesPayed onClose={() => openPackParent(null)} />
                  )}
                  {openParentPack === "RepairService" && (
                    <>
                      <ArrowLeft
                        className="close_icon"
                        onClick={() => openPackParent(null)}
                      />
                      <div className="PopupRepairService-content"></div>
                    </>
                  )}

                  {packLogosTypes.includes(openParentPack) && (
                    <div className="pack-popup-container">
                      <PackLogos
                        packType={openParentPack}
                        onClose={() => openPackParent(null)}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
